// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "webpack/" + chunkId + "." + {"187":"eb9ceea3ded65f901902","671":"0747b7cd4bcc4019c776","706":"130e1457435e7dd0bee6"}[chunkId] + ".js";
};